module.exports = __webpack_public_path__ + "static/media/logo@3x.f6de47f9.png";